// extracted by mini-css-extract-plugin
export default {"modalContent":"AddCategoryModal_modalContent__fv+Ig","modalForm":"AddCategoryModal_modalForm__SG-Au","modalTitle":"AddCategoryModal_modalTitle__6dA9B"};